import React from 'react';
import { camelCaseToTitleCase } from '../../../services/formatting';

import styles from './changelog.module.css';

export const Changelog = ({
    data,
    nameFunction,
    format,
    values
}) => {
    return (<>
        <h1>Change Log</h1>

        <div
            className={styles.ChangeLog}
            style={{
                columns: Math.min(3, Array.isArray(data) ? data.length : 0)
            }}
        >
            <ul>
                {
                    (data ?? []).map(r => (
                        <li className={styles.ChangeLogItem} key={r.id}>
                            <h3>{nameFunction(r) ?? ''}</h3>
                            <ul>
                                { Object.entries(format).map(([key, details]) => (
                                    ((
                                        details.didChange
                                        ? details.didChange(r, values)
                                        : values[key] !== null && values[key] !== r[key])
                                            ? <li key={key}>
                                                Changing <code>
                                                    {details.label ?? camelCaseToTitleCase(key)}
                                                </code> from <code>
                                                    {details.forChangeLog?.(r) ?? (
                                                        (!!details.fromApi?.(r) || !!r[key])
                                                            ? (details.fromApi?.(r) ?? r[key])
                                                            : 'None'
                                                    )}
                                                </code> to <code>
                                                    {details.forChangeLog?.(values) ?? (
                                                        !!values[key] ? values[key] : 'None'
                                                    )}
                                                </code>
                                            </li>
                                            : ''
                                    ))
                                )}
                            </ul>
                        </li>
                    ))
                }
            </ul>
        </div>
    </>)
}